import { useContext } from 'react';
import { PredefinedCommentsListContext } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/contexts/predefined-comments-list.context';

export const usePredefinedCommentsList = () => {
    const context = useContext(PredefinedCommentsListContext);
    if (!context) {
        throw new Error('usePredefinedCommentsList must be used within a PredefinedCommentsListProvider');
    }
    return context;
};
